import React, { Component } from 'react';
import Translate from 'react-translate-component';
import Columns from 'react-sortable-columns';
import { Checkbox, Select, Tooltip } from 'antd';
import { Row, Col } from 'antd/lib/grid';
import { adjust, assoc } from 'ramda';

import CustomIcon from 'components/common/CustomIcon';

export default class SettingsContent extends Component {
    state = {
        fields: this.props.settings.fields,
        stringHeight: this.props.settings.stringHeight,
        locked: this.props.settings.locked
    }

    onReorderFields = (fields) => {
        this.setState({
            fields
        });
    }

    onSelect = (value) => {
        this.setState({
            stringHeight: value
        });
    }

    onCheckboxChange = (e, index) => {
        this.setState({
            fields: adjust(index, assoc('value', e.target.checked), this.state.fields)
        });
    }

    setLock = (locked) => {
        locked = locked === this.state.locked ? locked - 1 : locked;

        this.setState({
            locked
        });
    }

    renderField = ({ item, index }) => {
        const { locked } = this.state;
        const { translatePrefix } = this.props;
        const isDisabled = item.hideable === false &&  item.value === true;

        const lockedIcon = index + 1 <= locked;

        return (
            <div className="settings-item">
                <Checkbox
                    checked={item.value}
                    disabled={isDisabled}
                    onChange={(e) => this.onCheckboxChange(e, index)}
                />
                <CustomIcon type={lockedIcon ? 'lock' : 'open'} onClick={() => this.setLock(index + 1)}/>
                <Translate content={translatePrefix + item.name} component="span"/>
            </div>
        );
    }

    render() {
        const { stringHeight, fields, locked }  = this.state;

        return (
            <div>
                <Row gutter={0} align="middle" type="flex">
                    <Col span={8}>
                        <Translate content="settings.stringHeight" />
                    </Col>
                    <Col span={12}>
                        <Select value={stringHeight} onSelect={this.onSelect}>
                            <Select.Option value="nolimit">
                                <Translate content="filterStatus.all" />
                            </Select.Option>
                            <Select.Option value="1">1</Select.Option>
                            <Select.Option value="2">2</Select.Option>
                            <Select.Option value="3">3</Select.Option>
                        </Select>
                    </Col>
                    <Col span={4} className="text-right">
                        <Tooltip title={<Translate content="settings.help" />} placement="bottom">
                            <CustomIcon type="info-outline" />
                        </Tooltip>
                    </Col>
                </Row>
                <div>
                    <Columns
                        list={fields}
                        getKey={item => item.name}
                        params={locked}
                        columns={2}
                        fixed={true}
                        width={340}
                        height={30}
                        ItemTemplate={this.renderField}
                        onChange={this.onReorderFields}
                    />
                </div>
            </div>
        );
    }
}
